import "./src/styles/global.css"
import wrapWithProvider from "./wrap-with-provider"

// Array of protected routes that require authentication
const protectedRoutes = [
  '/dashboard',
  '/profile',
  '/account',
  // Add all your protected routes here
];

// Callback for checking authentication before route transitions
export const onRouteUpdate = ({ location }) => {
  // Skip the check during SSR
  if (typeof window === 'undefined') return;
  
  // Check if the current route is protected
  const isProtectedRoute = protectedRoutes.some(route => 
    location.pathname === route || location.pathname.startsWith(`${route}/`)
  );
  
  if (isProtectedRoute) {
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    const token = localStorage.getItem('authToken');
    
    if (!isAuthenticated || !token) {
      // Not authenticated, redirect to login
      // No returnTo parameter, always go to dashboard after login
      window.___navigate('/login', { 
        state: { 
          message: 'Please log in to access this page'
        }
      });
    }
  }
};

// Keep your existing wrapRootElement export
export const wrapRootElement = wrapWithProvider;